import React from "react";
import { FormControlLabel, Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { Radio } from "@mui/material";

const BpIcon = styled("span")({
  border: "1px solid",
  borderImageSource:
    "linear-gradient(0deg, #4B465C, #4B465C), linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8))",
  background: "#FFFFFF",
  width: 18,
  height: 18,
  borderRadius: "100px",
  boxSizing: "border-box",
});

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#FFFFFF",
  border: "5px solid #00B3B5",
  "&::before": {
    display: "block",
    width: 0,
    height: 18,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: '""',
  },
});

const RadioButton = styled((props: any) => (
  <Radio checkedIcon={<BpCheckedIcon />} icon={<BpIcon />} {...props} />
))(({ theme }) => ({}));

interface RadioOption {
  value: string;
  label: string;
}
interface CustomRadioGroupProps {
  label?: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  hasBg?: boolean;
  isRequired?: boolean;
  error?: boolean;
  helperText?: string | null;
  disabled?: boolean;
}

export const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
  label,
  options,
  value,
  onChange,
  hasBg,
  isRequired,
  error,
  helperText,
  disabled,
}) => (
  <Box>
    <Box
      sx={{
        display: hasBg ? "block" : "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        gap: { xs: "10px", sm: 0 },
      }}
    >
    <Typography
      sx={{
        fontWeight: 400,
        fontSize: "11px",
        lineHeight: "21px",
        letterSpacing: "0px",
        color: "#5d586c",
        marginBottom: { xs: "10px", sm: 0 },
        marginRight: { sm: "15px" },
      }}
    >
      {label}
      {isRequired && <span style={{ color: "red" }}> *</span>}
    </Typography>

    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        mt: hasBg ? 2 : 0,
      }}
    >
      {options.map((option, index) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={<RadioButton disabled={disabled} />}
          disabled={disabled}
          label={
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "100%",
                letterSpacing: "0%",
                textAlign: "left",
                color: disabled ? "#8a8a8a" : "#000000",
                width: "100%",
                display: "inline-block",
                borderRadius: "4px",
                padding: "2px 0px",
              }}
            >
              {option.label}
            </Typography>
          }
          checked={value === option.value}
          onChange={() => {
            if (!disabled) onChange(option.value);
          }}
          sx={
            hasBg
              ? {
                  background: "#00B3B514",
                  border: "2px dotted #00B3B5",
                  minWidth: "145px",
                  height: "44px",
                  borderRadius: "24px",
                  padding: "12px 10px",
                  display: "flex",
                  alignItems: "center",
                  boxSizing: "border-box",
                  m: 0,
                }
              : {
                  marginLeft: { xs: index === 0 ? "0px" : "15px", sm: "15px" },
                  marginRight: "0px",
                }
          }
        />
      ))}
    </Box>
    </Box>
    {error && helperText ? (
      <Typography
        variant="caption"
        sx={{ display: "block", color: "#d32f2f", mt: 0.5 }}
      >
        {helperText}
      </Typography>
    ) : null}
  </Box>
);
